// RULES UPDATED DECEMBER 2025
//TODO ADD MODIFICATIONS ON OTHER RULES.JS FILES THEN REFACTOR INTO ONE COMMON RULES.JS FILE IF POSSIBLE
//TODO MOVE INTO CONSTANT FILE
const DEBUT = 'Début';
const FIN = 'Fin';
const NON_DEMARRE = 'Non-démarré';
const MI_TEMPS_1 = '1ère période';
const MI_TEMPS_2 = '2ème période';
const PROLONGATION = 'Prolongation';
const PERIODE_1 = '1ère prolongation';
const PERIODE_2 = '2ème prolongation';
const TIRS_AU_BUT = 'Tirs au but';
const TERMINE = 'Match terminé';

const QUART_TEMPS_1 = '1er quart temps';
const QUART_TEMPS_2 = '2e quart temps';
const QUART_TEMPS_3 = '3e quart temps';
const QUART_TEMPS_4 = '4e quart temps';
const QUART_TEMPS_5 = '5e quart temps';
const QUART_TEMPS_6 = '6e quart temps';
const QUART_TEMPS_7 = '7e quart temps';
const QUART_TEMPS_8 = '8e quart temps';
const QUART_TEMPS_9 = '9e quart temps';
const QUART_TEMPS_10 = '10e quart temps';

const TYPE_MAIN = 'main';
const TYPE_SUB = 'sub';
const TYPE_MATCH_END = 'match_end';
const TYPE_OTHER = 'other';

const COMPO_CONSTANTS = {
    BASKET: {name:'basket5',holdersNumber:5},
    HANDBALL: {name:'handball7',holdersNumber:7},
    SOCCER: {name:'442',holdersNumber:11},
    RUGBY: {name:'rugby15',holdersNumber:15}
};

/**
 * Model for Match's Period
 * @param {string} name : Period's name
 * @param {string} periodType : Period's type (/ex: main, sub)
 * @param {int} minDuration : Period's default duration in minutes at period's start
 * @param {boolean} isPlayable : is Period a playable or technical period in game (ex: playable period:1st Half, or technical period: 1st Half end)
 * @param {int} playedStepInGame : Period's step in game for Period played 
 * @param {int} matchPeriod : Period's step in match (all steps)
 * @param {int} periodPhase : Period's phase in game
 * 
 *  
 * 
 * Usage: 
 * - let firstHalf = new PeriodModel('1st Half', 45, true, false); --> period creation
 * - firstHalf.display(); --> Outputs the details of the period
 * - firstHalf.updatePeriod('1st Half Extended', 60, true, false); --> Updating the period information
 * 
 */
class PeriodModel {
    constructor(name, periodType, minDuration, isPlayable, playedStepInGame, matchPeriod, periodPhase, options = {}) {
        this.name = name;
        this.minDuration = minDuration;
        this.isPlayable = isPlayable;
        this.playedStepInGame = playedStepInGame;
        this.periodType = periodType;
        this.matchPeriod = matchPeriod;
        this.periodPhase = periodPhase;
        // Nouveau : flags optionnels
        this.isRegulationEnd = options.isRegulationEnd === true;
        this.maxDuration = options.maxDuration || null;
    }

    updatePeriod(name, periodType, minDuration, isPlayable, playedStepInGame, matchPeriod, periodPhase, options = {}) {
        this.name = name;
        this.minDuration = minDuration;
        this.isPlayable = isPlayable;
        this.playedStepInGame = playedStepInGame;
        this.periodType = periodType;
        this.matchPeriod = matchPeriod;
        this.periodPhase = periodPhase;
        this.isRegulationEnd = options.isRegulationEnd === true;
        this.maxDuration = options.maxDuration || null;
    }

    display() {
        console.log(`Period: ${this.name}, periodType: ${this.periodType}, minDuration: ${this.minDuration} minutes, isPlayable: ${this.isPlayable}, playedStepInGame: ${this.playedStepInGame} matchPeriod: ${this.matchPeriod}, periodPhase:${this.periodPhase}`);
    }
}

// Actual min match ended durations :
// Soccer : 90 (2 × 45)
// Rugby : 80 (2 × 40)
// Handball : 60 (2 × 30)
// Basket : 40 (4 × 10)


// DUPLICATION IN SERVER FOR NOW - into server/utils/rules/rules.js

// Default match position / composition for given discipline 
export class MatchComposition {
    constructor(discipline) {
        // Uppercase on discipline
        const upperDiscipline = discipline.toUpperCase();

        // Get compo with given uppercase discipline
        this.name = COMPO_CONSTANTS[upperDiscipline]?.name;
        this.holdersNumber = COMPO_CONSTANTS[upperDiscipline]?.holdersNumber;

        if (!this.composition) {
            throw new Error(`Composition non trouvée pour la discipline: ${discipline}`);
        }
    }
}

/**
 * Model for Match's Sheet (feuille de match)
 * @param {string} discipline : Match Sheet discipline
 * @param {string} provider : Match Sheet provider
 * @param {string} match : Match Sheet match (to fill: day, dateTime, homeTeam, awayTeam, homeCoach, awayCoach,
 *                          homeSubstitutes, awaySubstitutes, provider, discipline) 
 * @param {string} season : Match Sheet season
 * @param {string} homeComposition : Match Sheet composition for home team (if not filed, is default value for discipline)
 * @param {string} awayComposition : Match Sheet composition for away team (if not filed, is default value for discipline)
 */
export class MatchSheetModel {

    //Default basic match sheet model
    constructor(discipline, provider ) {

        const composition = new MatchComposition(discipline);

        this.competition = '';
        this.season = '';
        this.day = '';
        this.dateTime = new Date();
        this.homeTeam = '';
        this.homeCoach = '';
        this.awayCoach = '';
        this.homeComposition = composition.name;
        this.homeHolders = [];
        this.homeSubstitutes = [];
        this.awayTeam = '';
        this.awayComposition = composition.name;
        this.awayHolders = [];
        this.awaySubstitutes = [];
        this.provider = provider;
        this.discipline = discipline;
    }

    updateMatchSheet(match, season, homeComposition=null, awayComposition=null) {

        const composition = new MatchComposition(match.discipline);
        const homeCompo = homeComposition ? homeComposition : composition.name;
        const awayCompo = awayComposition ? awayComposition : composition.name;
        

        this.competition = match.competition;
        this.season = season;
        this.day = match.day;
        this.dateTime = match.dateTime;
        this.homeTeam = match.homeTeam._id;
        this.homeCoach = match.homeCoach;
        this.awayCoach = match.awayCoach;
        this.homeComposition = homeCompo;
        this.homeHolders = match.homeHolders?.length > 0 ? [...match.homeHolders] : this.homeHolders;
        this.homeSubstitutes = match.homeSubstitutes?.length > 0 ? [...match.homeSubstitutes] : this.homeSubstitutes;
        this.awayTeam = match.awayTeam._id;
        this.awayComposition = awayCompo;
        this.awayHolders = match.awayHolders?.length > 0 ? [...match.awayHolders] : this.awayHolders;
        this.awaySubstitutes = match.awaySubstitutes?.length > 0 ? [...match.awaySubstitutes] : this.awaySubstitutes;
        this.provider = match.provider;
        this.discipline = match.discipline;
    }
}

export const rugbyRules = {
    periodDuration : {
        main : 40,
        sub : 10,
    },
    getPeriods: function() {
        return new Map([
        // Period: ${this.name}, periodType: ${this.periodType}, minDuration: ${this.minDuration} minutes, isPlayable: ${this.isPlayable}, 
        //playedStepInGame: ${this.playedStepInGame} matchPeriod: ${this.matchPeriod}, periodPhase:${this.periodPhase}
        [0, new PeriodModel(NON_DEMARRE, TYPE_OTHER, 0, false, null, 0,'start')],
        [1, new PeriodModel(MI_TEMPS_1, TYPE_MAIN, 0, true, 1, 0,'mt', {maxDuration: 40})],
        [2, new PeriodModel(FIN + ' ' + MI_TEMPS_1, TYPE_OTHER, this.periodDuration.main, false, null, 1,'mt_end', {maxDuration: 40})],
        [3, new PeriodModel(MI_TEMPS_2, TYPE_MAIN, this.periodDuration.main, true, 2, 1,'mt2', {maxDuration: 80})],
        [4, new PeriodModel(FIN + ' ' + MI_TEMPS_2, TYPE_OTHER, this.periodDuration.main * 2, false, null, 3,'mt2_end', {maxDuration: 80})],
        [5, new PeriodModel(PERIODE_1, TYPE_SUB, this.periodDuration.main * 2, true, 3, 3,'ot', {maxDuration: 90})],
        [6, new PeriodModel(FIN + ' ' + PERIODE_1, TYPE_OTHER, this.periodDuration.main * 2 + this.periodDuration.sub, false, null, 4,'ot_end', {maxDuration: 90})],
        [7, new PeriodModel(PERIODE_2, TYPE_SUB, this.periodDuration.main * 2 + this.periodDuration.sub, true, 4, 4,'ot2', {maxDuration: 100})],
        [8, new PeriodModel(FIN + ' ' + PERIODE_2, TYPE_OTHER, this.periodDuration.main * 2 + this.periodDuration.sub * 2, false, null, 5,'ot2_end', {maxDuration: 100})],
        [9, new PeriodModel(TIRS_AU_BUT, TYPE_OTHER, this.periodDuration.main * 2, true, 5, 5,'so', {maxDuration: 100})],
        [10, new PeriodModel(TERMINE, TYPE_OTHER, this.periodDuration.main * 2, false, null, 6,'end', {maxDuration: 100})]
    ])},

    getPlayedGamesPeriods: function() {
        const allPeriods = this.getPeriods();
        let playablePeriods = new Map();
    
        // Iterate over all periods and add the playable ones to the playablePeriods array
        for (const [key, periodModel] of allPeriods) {
            if (periodModel.isPlayable) {
                playablePeriods.set(periodModel.matchPeriod, periodModel);
            }
        }
    
        return playablePeriods;
    },

    getUnplayableGamesPeriods: function() {
        const allPeriods = this.getPeriods();
        let unplayablePeriods = new Map();
    
        // Iterate over all periods and add the playable ones to the playablePeriods array
        for (const [key, periodModel] of allPeriods) {
            if (!periodModel.isPlayable) {
                unplayablePeriods.set(periodModel.matchPeriod, periodModel);
            }
        }
    
        return unplayablePeriods;
    },

//TODO REFACTO - USE ON useMatchTimer + Chrono + others
//add to other disciplines
// add to duplicates rules.js files
    getPeriodPlayedModel: function(matchPeriod ) {
        const allPeriods = this.getPlayedGamesPeriods();
        const periodModel = [...allPeriods.values()]
            .find(p => p.matchPeriod === matchPeriod);

        return periodModel;
        },

    getPeriodModel: function(matchPeriod) {
        const allPeriods = this.getPeriods();
        const periodModel = [...allPeriods.values()]
            .find(p => p.matchPeriod === matchPeriod);

        return periodModel;
        },

    getMinTotalDuration : function(period){ 

        const periodValue = period || 0;
        
        let periodModel = this.getPeriodPlayedModel(periodValue);
        if (!periodModel){
            periodModel = this.getPeriodModel(periodValue)
            //TODO OPTA PER 2 - bout de scotch là
                if (!periodModel){
                    periodModel = this.getPeriodModel(6);
                }
            }

            return periodModel.minDuration;
        },

    getMaxTotalDuration : function(period){
        let periodModel = this.getPeriodPlayedModel(period);
        if (!periodModel){
            periodModel = this.getPeriodModel(period)
            //TODO OPTA PER 2 - bout de scotch là
                if (!periodModel){
                    periodModel = this.getPeriodModel(6);
                }
            }
            return periodModel.maxDuration;
    },

    getActualPeriodDuration : function(period){ 
        return period <= 2 ? 
            this.periodDuration.main : 
            this.periodDuration.sub
    },
    getTotalTimer : function(period, timer){
        const minutes = timer / 60;
        const totalMin = period <= 2 ? 
            period * this.periodDuration.main + minutes :
            2 * this.periodDuration.main + (period - 3) * this.periodDuration.sub + minutes
        return totalMin * 60
    },
    getTimerList : function(period, maxTimer){
        const minTimer = period < 2 ? period * this.periodDuration.main : 2 * this.periodDuration.main + (period - 3) * this.periodDuration.sub

        let timerList = []

        if(period === 2)
            timerList.push({id : 0, value : this.periodDuration.main * 2})
        else if(period === 5 || period === 6)
            timerList.push({id : 0, value : this.periodDuration.main * 2 + this.periodDuration.sub * 2})
        else
            for(var i = 0 ; i <= maxTimer ; i++){
                timerList.push({id : i, value : i + minTimer})
            }

        return timerList
    }
}

export const soccerRules = {
    periodDuration : {
        main : 45,
        sub : 15,
    },
    getPeriods: function() {
        return new Map([
        // Period: ${this.name}, periodType: ${this.periodType}, minDuration: ${this.minDuration} minutes, isPlayable: ${this.isPlayable}, 
        //playedStepInGame: ${this.playedStepInGame} matchPeriod: ${this.matchPeriod}, periodPhase:${this.periodPhase}
        [0, new PeriodModel(NON_DEMARRE, TYPE_OTHER, 0, false, null, 0,'start')],
        [1, new PeriodModel(MI_TEMPS_1, TYPE_MAIN, 0, true, 1, 0,'mt', {maxDuration: 45})],
        [2, new PeriodModel(FIN + ' ' + MI_TEMPS_1, TYPE_OTHER, this.periodDuration.main, false, null, 1,'mt_end', {maxDuration: 45})],
        [3, new PeriodModel(MI_TEMPS_2, TYPE_MAIN, this.periodDuration.main, true, 2, 1,'mt2', {maxDuration: 90})],
        [4, new PeriodModel(FIN + ' ' + MI_TEMPS_2, TYPE_OTHER, this.periodDuration.main * 2, false, null, 3,'mt2_end', {maxDuration: 90})],
        [5, new PeriodModel(PERIODE_1, TYPE_SUB, this.periodDuration.main * 2, true, 3, 3,'ot', {maxDuration: 105})],
        [6, new PeriodModel(FIN + ' ' + PERIODE_1, TYPE_OTHER, this.periodDuration.main * 2 + this.periodDuration.sub, false, null, 4,'ot_end', {maxDuration: 105})],
        [7, new PeriodModel(PERIODE_2, TYPE_SUB, this.periodDuration.main * 2 + this.periodDuration.sub, true, 4, 4,'ot2', {maxDuration: 120})],
        [8, new PeriodModel(FIN + ' ' + PERIODE_2, TYPE_OTHER, this.periodDuration.main * 2 + this.periodDuration.sub * 2, false, null, 5,'ot2_end', {maxDuration: 120})],
        [9, new PeriodModel(TIRS_AU_BUT, TYPE_OTHER, this.periodDuration.main * 2, true, 5, 5,'so', {maxDuration: 120})],
        [10, new PeriodModel(TERMINE, TYPE_OTHER, this.periodDuration.main * 2, false, null, 6,'end', {maxDuration: 120})]
    ])},

    getPlayedGamesPeriods: function() {
        const allPeriods = this.getPeriods();
        let playablePeriods = new Map();
    
        // Iterate over all periods and add the playable ones to the playablePeriods array
        for (const [key, periodModel] of allPeriods) {
            if (periodModel.isPlayable) {
                playablePeriods.set(periodModel.matchPeriod, periodModel);
            }
        }
    
        // Logging the count for debugging purpose
       // console.log('Playable Periods Count = ', playablePeriods.length);
    
        return playablePeriods;
    },

    getUnplayableGamesPeriods: function() {
        const allPeriods = this.getPeriods();
        let unplayablePeriods = new Map();
    
        // Iterate over all periods and add the playable ones to the playablePeriods array
        for (const [key, periodModel] of allPeriods) {
            if (!periodModel.isPlayable) {
                unplayablePeriods.set(periodModel.matchPeriod, periodModel);
            }
        }
    
        // Logging the count for debugging purpose
       // console.log('Playable Periods Count = ', playablePeriods.length);
    
        return unplayablePeriods;
    },

    //TODO refactoring use PeriodModel...
    getMinTotalDuration : function(period){ 
        const periodValue = period || 0;
            let value;

            if (periodValue <= 2) {
                // Périodes temps réglementaire : matchPeriod 0,1,2
                value = periodValue * this.periodDuration.main;
            } else if (periodValue >= 5) {
                // Match terminé : on force le minimum à 90 minutes (fin du temps réglementaire)
                value = 2 * this.periodDuration.main;
            } else {
                // Prolongations / TAB : matchPeriod 3,4,5
                value = 2 * this.periodDuration.main + (periodValue - 3) * this.periodDuration.sub;
            }

            return value;
        },

    getMaxTotalDuration : function(period){
        let periodModel = this.getPeriodPlayedModel(period);
        if (!periodModel){
            periodModel = this.getPeriodModel(period)
            //TODO OPTA PER 2 - bout de scotch là
                if (!periodModel){
                    periodModel = this.getPeriodModel(6);
                }
            }
            return periodModel.maxDuration;
    },

        //TODO refactoring into PeriodModels
    getActualPeriodDuration : function(period){ 
        switch(period){
            case 0:
            case 1:
                return this.periodDuration.main
            case 3:
            case 4:
                return this.periodDuration.sub
            default :
                return 0
        }
    },
    getTotalTimer : function(period, timer){
        const minutes = timer / 60;
        const totalMin = period <= 2 ? 
            period * this.periodDuration.main + minutes :
            2 * this.periodDuration.main + (period - 3) * this.periodDuration.sub + minutes
        return totalMin * 60
    },
    getTimerList : function(period, maxTimer){
        const minTimer = period < 2 ? period * this.periodDuration.main : 2 * this.periodDuration.main + (period - 3) * this.periodDuration.sub

        let timerList = []

        if(period === 2)
            timerList.push({id : 0, value : this.periodDuration.main * 2})
        else if(period === 5 || period === 6)
            timerList.push({id : 0, value : this.periodDuration.main * 2 + this.periodDuration.sub * 2})
        else
            for(var i = 0 ; i <= maxTimer ; i++){
                timerList.push({id : i, value : i + minTimer})
            }

        return timerList
    }
}

export const basketRules = {
    periodDuration : {
        main : 10,
        sub: 5,
    },
    getPeriods: function() {
        return new Map([
        // Period: ${this.name}, periodType: ${this.periodType}, minDuration: ${this.minDuration} minutes, isPlayable: ${this.isPlayable}, 
        //playedStepInGame: ${this.playedStepInGame} matchPeriod: ${this.matchPeriod}, periodPhase:${this.periodPhase}
        [0, new PeriodModel(NON_DEMARRE, TYPE_OTHER, 0, false, null, 0,'start')],
        [1, new PeriodModel(QUART_TEMPS_1, TYPE_MAIN, 0, true, 1, 0,'mt', {maxDuration: 10})],
        [2, new PeriodModel(FIN + ' ' + QUART_TEMPS_1, TYPE_OTHER, this.periodDuration.main, false, null, 1,'mt_end', {maxDuration: 10})],
        [3, new PeriodModel(QUART_TEMPS_2, TYPE_MAIN, this.periodDuration.main, true, 2, 1,'mt', {maxDuration: 20})],
        [4, new PeriodModel(FIN + ' ' + QUART_TEMPS_2, TYPE_OTHER, this.periodDuration.main * 2, false, null, 2,'mt_end', {maxDuration: 20})],
        [5, new PeriodModel(QUART_TEMPS_3, TYPE_MAIN, this.periodDuration.main * 2, true, 3, 2,'mt', {maxDuration: 30})],
        [6, new PeriodModel(FIN + ' ' + QUART_TEMPS_3, TYPE_OTHER, this.periodDuration.main * 3, false, null, 3,'mt_end', {maxDuration: 30})],
        [7, new PeriodModel(QUART_TEMPS_4, TYPE_MAIN, this.periodDuration.main * 3, true, 4, 3,'mt', {maxDuration: 40})],
        [8, new PeriodModel(FIN + ' ' + QUART_TEMPS_4, TYPE_OTHER, this.periodDuration.main * 4, false, null, 4,'mt_end', {maxDuration: 40})],
        [9, new PeriodModel(QUART_TEMPS_5, TYPE_MAIN, this.periodDuration.main * 4, true, 5, 4,'mt', {maxDuration: 45})],
        [10, new PeriodModel(FIN + ' ' + QUART_TEMPS_5, TYPE_OTHER, this.periodDuration.main * 4 + this.periodDuration.sub, false, null, 5,'mt_end', {maxDuration: 45})],
        [11, new PeriodModel(QUART_TEMPS_6, TYPE_MAIN, this.periodDuration.main * 4 + this.periodDuration.sub, true, 6, 5,'mt', {maxDuration: 50})],
        [12, new PeriodModel(FIN + ' ' + QUART_TEMPS_6, TYPE_OTHER, this.periodDuration.main * 4 + this.periodDuration.sub*2, false, null, 6,'mt_end', {maxDuration: 50})],
        [13, new PeriodModel(QUART_TEMPS_7, TYPE_MAIN, this.periodDuration.main * 4 + this.periodDuration.sub*2, true, 7, 6,'mt', {maxDuration: 55})],
        [14, new PeriodModel(FIN + ' ' + QUART_TEMPS_7, TYPE_OTHER, 55, false, null, 7,'mt_end', {maxDuration: 55})],
        [15, new PeriodModel(QUART_TEMPS_8, TYPE_MAIN, 55, true, 8, 7,'mt', {maxDuration: 60})],
        [16, new PeriodModel(FIN + ' ' + QUART_TEMPS_8, TYPE_OTHER, 60, false, null, 8,'mt_end', {maxDuration: 60})],
        [17, new PeriodModel(QUART_TEMPS_9, TYPE_MAIN, 60, true, 9, 8,'mt', {maxDuration: 65})],
        [18, new PeriodModel(FIN + ' ' + QUART_TEMPS_9, TYPE_OTHER, 65 + this.periodDuration.sub*8, false, null, 9,'mt_end', {maxDuration: 65})],
        [19, new PeriodModel(QUART_TEMPS_10, TYPE_MAIN, 65, true, 10, 9,'mt', {maxDuration: 70})],
        [20, new PeriodModel(TERMINE, TYPE_OTHER, this.periodDuration.main * 4, false, null, 10,'end', {maxDuration: 70})]
    ])},

    getPlayedGamesPeriods: function() {
        const allPeriods = this.getPeriods();
        let playablePeriods = new Map();
    
        // Iterate over all periods and add the playable ones to the playablePeriods array
        for (const [key, periodModel] of allPeriods) {
            if (periodModel.isPlayable) {
                playablePeriods.set(periodModel.matchPeriod, periodModel);
            }
        }
    
        return playablePeriods;
    },

    getUnplayableGamesPeriods: function() {
        const allPeriods = this.getPeriods();
        let unplayablePeriods = new Map();
    
        // Iterate over all periods and add the playable ones to the playablePeriods array
        for (const [key, periodModel] of allPeriods) {
            if (!periodModel.isPlayable) {
                unplayablePeriods.set(periodModel.matchPeriod, periodModel);
            }
        }
    
        return unplayablePeriods;
    },
    //TODO REFACTO - USE ON useMatchTimer + Chrono + others
    //add to other disciplines
    // add to duplicates rules.js files
    getPeriodPlayedModel: function(matchPeriod ) {
        const allPeriods = this.getPlayedGamesPeriods();
        const periodModel = [...allPeriods.values()]
            .find(p => p.matchPeriod === matchPeriod);

        return periodModel;
        },

    getPeriodModel: function(matchPeriod) {
        const allPeriods = this.getPeriods();
        const periodModel = [...allPeriods.values()]
            .find(p => p.matchPeriod === matchPeriod);

        return periodModel;
        },

    getMinTotalDuration : function(period){ 
        const periodValue = period || 0;
        let periodModel = this.getPeriodPlayedModel(periodValue);
        if (!periodModel){
            periodModel = this.getPeriodModel(periodValue)
            //TODO OPTA PER 2 - bout de scotch là
                if (!periodModel){
                    periodModel = this.getPeriodModel(10);
                }
            }
            return periodModel.minDuration;
    },
    getActualPeriodDuration : function(period){ 
        return period < 4 ? this.periodDuration.main : this.periodDuration.sub
    },
    getMaxTotalDuration : function(period){
        let periodModel = this.getPeriodPlayedModel(period);
        if (!periodModel){
            periodModel = this.getPeriodModel(period)
            //TODO OPTA PER 2 - bout de scotch là
                if (!periodModel){
                    periodModel = this.getPeriodModel(10);
                }
            }
            return periodModel.maxDuration;
    },
    getTotalTimer : function(period, timer){
        const minutes = timer / 60;
        const totalMin = period * this.periodDuration.main + minutes
        return totalMin * 60
    },
    //TODO REFACTORING
    getTimerList : function(period, maxTimer){
        const minTimer = period * this.periodDuration.main

        let timerList = []

        for(var i = 0 ; i <= maxTimer ; i++){
            timerList.push({id : i, value : i + minTimer})
        }

        return timerList
    }
}

export const handballRules = {
    periodDuration: {
        main: 30,  // Principale : durée de chaque mi-temps (minutes)
        sub: 10, 
        //TODO refacto même logiques tout sports
        match_end: 60, // Durée totale minimale du match (minutes)
        other: 0   // Uniquement technique, pas de durée de jeu
    },

    getPeriods: function() {
        return new Map([
        // Period: ${this.name}, periodType: ${this.periodType}, minDuration: ${this.minDuration} minutes, isPlayable: ${this.isPlayable}, 
        //playedStepInGame: ${this.playedStepInGame} matchPeriod: ${this.matchPeriod}, periodPhase:${this.periodPhase}
        [0, new PeriodModel(NON_DEMARRE, TYPE_OTHER, 0, false, null,0,'start')],
        [1, new PeriodModel(MI_TEMPS_1, TYPE_MAIN, 0, true, 1, 0,'mt', {maxDuration: 30})],
        [2, new PeriodModel(FIN + ' ' + MI_TEMPS_1, TYPE_MAIN, this.periodDuration.main, false, null, 1,'mt_end', {maxDuration: 30})],
        [3, new PeriodModel(MI_TEMPS_2, TYPE_MAIN, this.periodDuration.main, true, 2, 1,'mt2', {maxDuration: 60})],
        [4, new PeriodModel(FIN + ' ' + MI_TEMPS_2, TYPE_MAIN, this.periodDuration.main * 2, false, null, 2,'mt2_end', {maxDuration: 60})],
        [5, new PeriodModel(PERIODE_1, TYPE_SUB, this.periodDuration.main * 2, true, 3, 2,'ot', {maxDuration: 70})],
        [6, new PeriodModel(FIN + ' ' + PERIODE_1, TYPE_SUB, this.periodDuration.main * 2 + this.periodDuration.sub + this.periodDuration.sub, false, null, 3,'ot_end', {maxDuration: 70})],
        [7, new PeriodModel(PERIODE_2, TYPE_SUB, this.periodDuration.main * 2 + this.periodDuration.sub, true, 4, 3,'ot2', {maxDuration: 80})],
        [8, new PeriodModel(FIN + PERIODE_2, TYPE_SUB, this.periodDuration.main * 2 + this.periodDuration.sub * 2, false, null, 4,'ot2_end', {maxDuration: 80})],
        [9, new PeriodModel(TIRS_AU_BUT, TYPE_SUB, this.periodDuration.main * 2, true, 5, 4,'so', {maxDuration: 80})],
        [10, new PeriodModel(TERMINE, TYPE_OTHER, this.periodDuration.main * 2, false, null, 5,'end', {maxDuration: 80})]
    ])},
    getUnplayableGamesPeriods: function() {
        const allPeriods = this.getPeriods();
        let unplayablePeriods = new Map();
    
        // Iterate over all periods and add the playable ones to the playablePeriods array
        for (const [key, periodModel] of allPeriods) {
            if (!periodModel.isPlayable) {
                unplayablePeriods.set(periodModel.matchPeriod, periodModel);
            }
        }
    
        // Logging the count for debugging purpose
       // console.log('Playable Periods Count = ', playablePeriods.length);
    
        return unplayablePeriods;
    },

    /**
     *  périodes normales / prolongations → (0, 30, 60, 70, 80, etc.)
        period = 10 (match terminé) → 60
     */

//TODO refactoring use PeriodModel...
    getMinTotalDuration : function(period){ 
        const periodValue = period || 0;
            let value;

            if (periodValue <= 2) {
                // Périodes temps réglementaire : matchPeriod 0,1,2
                value = periodValue * this.periodDuration.main;
            } else if (periodValue >= 5) {
                // Match terminé : on force le minimum à 60 minutes (fin du temps réglementaire)
                value = 2 * this.periodDuration.main;
            } else {
                
                value = this.getPeriods().get(period).minDuration;
            }

            return value;
    },
    //TODO refactoring sur les autres sports comme ici
    // getActualPeriodDuration: function(period){ 
    //     //TODO nullable
    //     console.log('handballRules - getActualPeriodDuration - period : ', period);
    //     let periodType = this.getPeriods().get(period).periodType;
    //     let duration = this.periodDuration[periodType];
    //     return duration;
    // },
     getActualPeriodDuration : function(period){ 
        switch(period){
            case 0:
            case 1:
                return this.periodDuration.main
            case 3:
            case 4:
                return this.periodDuration.sub
            default :
                return 0
        }
    },
    getMaxTotalDuration : function(period){
        const currentPeriod = this.getPeriods().get(period)
        let duration = this.periodDuration[currentPeriod.periodType];
        //TODO refactoring use currentPeriodType for addition and not main by default
        return currentPeriod.maxDuration || (currentPeriod.minDuration + duration)
    },
    //TODO refactoring idem se servir des fonctions hand sur les autres sports
    getTotalTimer: function(period, timer){
        // Temps total en secondes (avec timer en cours)
        const minutes = timer / 60;
        const totalMin = this.getMinTotalDuration(period) + minutes;
        return totalMin * 60;
    },
    getTimerList: function(period, maxTimer){
        // Génère une liste de valeurs de timer pour la période donnée
        let minTimer = this.getMinTotalDuration(period);

        let timerList = [];

        for(var i = 0; i <= maxTimer; i++){
            timerList.push({id: i, value: i + minTimer});
        }

        return timerList;
    },

    getPeriodByMatchStep: function(step){
        return this.getPeriods().get(step);
    },

    getPeriodByType: function(type){
        //TODO nullable
        const periods = this.getPeriods();

        for (const [key, periodModel] of periods) {
            if (periodModel.periodPhase === type) {
                return periodModel;
            }
        }
    },

    getPlayedGamesPeriods: function() {
        const allPeriods = this.getPeriods();
        let playablePeriods = new Map();
    
        // Iterate over all periods and add the playable ones to the playablePeriods array
        for (const [key, periodModel] of allPeriods) {
            if (periodModel.isPlayable) {
                playablePeriods.set(key, periodModel);
            }
        }
    
        // Logging the count for debugging purpose
       // console.log('Playable Periods Count = ', playablePeriods.length);
    
        return playablePeriods;
    },
    //TODO REFACTO - USE ON useMatchTimer + Chrono + others
    //add to other disciplines
    // add to duplicates rules.js files
    getPeriodPlayedModel: function(matchPeriod ) {
        const allPeriods = this.getPlayedGamesPeriods();
        const periodModel = [...allPeriods.values()]
            .find(p => p.matchPeriod === matchPeriod);

        return periodModel;
        },

    getPeriodModel: function(matchPeriod) {
        const allPeriods = this.getPeriods();
        const periodModel = [...allPeriods.values()]
            .find(p => p.matchPeriod === matchPeriod);

        return periodModel;
        },

    getSurchagePeriod: function(currentPeriod) {

        const allPlayablePeriods = this.getPlayedGamesPeriods();
        const allPeriods = this.getPeriods();

        if (allPeriods.get(currentPeriod).isPlayable){
            return allPeriods.get(currentPeriod);
        }

        for (const [key, value] of allPlayablePeriods) {
            if (key > currentPeriod) {
                return value;
                }
            }
        }

}



// COMMON LOGIC

export const getMaxTotalDuration = (period, discipline) => {
    switch(discipline){
        case 'soccer':
            return soccerRules.getMaxTotalDuration(period)
        case 'rugby' : 
            return rugbyRules.getMaxTotalDuration(period)
        case 'basket' :
            return basketRules.getMaxTotalDuration(period)
        case 'handball':
            return handballRules.getMaxTotalDuration(period)
        default:
            console.error("Discipline non reconnue pour le calcul de la durée totale de temps de periode");
            return 0;
    }
    
}

export const getMinTotalDuration = (period, discipline) => {
    switch(discipline){
        case 'soccer':
            return soccerRules.getMinTotalDuration(period)
        case 'rugby' : 
            return rugbyRules.getMinTotalDuration(period)
        case 'basket' :
            return basketRules.getMinTotalDuration(period)
        case 'handball':
            return handballRules.getMinTotalDuration(period)
        default:
            console.error("Discipline non reconnue pour le calcul de la durée totale de temps");
            return 0;
    }
}

export const getActualPeriodDuration = (period, discipline) => {
    switch(discipline){
        case 'soccer':
            return soccerRules.getActualPeriodDuration(period)
        case 'rugby' : 
            return rugbyRules.getActualPeriodDuration(period)
        case 'basket' :
            return basketRules.getActualPeriodDuration(period)
        case 'handball':
            return handballRules.getActualPeriodDuration(period);
        default:
            console.error("Discipline non reconnue pour le calcul du temps de la période courante");
            return 0;
    }
}

export const getTotalTimer = (period, timer, discipline) => {

    switch(discipline){
        case 'soccer':
            return soccerRules.getTotalTimer(period, timer)
        case 'rugby' : 
            return rugbyRules.getTotalTimer(period, timer)
        case 'basket' :
            return basketRules.getTotalTimer(period, timer)
        case 'handball':
            return handballRules.getTotalTimer(period, timer);
        default:
            console.error("Discipline non reconnue pour le timer");
            return 0;
    }
}

export const getTimerList = (period, maxTimer, discipline) => {

    switch(discipline){
        case 'soccer':
            return soccerRules.getTimerList(period, maxTimer)
        case 'rugby' : 
            return rugbyRules.getTimerList(period, maxTimer)
        case 'basket' :
            return basketRules.getTimerList(period, maxTimer)
        case 'handball':
            return handballRules.getTimerList(period, maxTimer);
        default:
            console.error("Discipline non reconnue pour le calcul de des durées de périodes");
            return [];
    }

}

//TODO refactoring check with GenericUtils same method name & merge
export const getVisualTimer = (period, timer, discipline) => {

    //TODO log opta shootout period / timer 

    const minTotalDuration = getMinTotalDuration(period, discipline)
    const actualPeriodDuration = getActualPeriodDuration(period, discipline)

    let leftPartTimer = Math.min(timer, actualPeriodDuration) + minTotalDuration

    let rightPartTimer = timer - leftPartTimer + minTotalDuration
    
    return rightPartTimer ? leftPartTimer+"'(+"+rightPartTimer+")" : leftPartTimer+"'"
}

//TODO
export const getPeriod = (period, discipline) => {

    const errtxt = "Discipline non implémentée getPeriod pour :" + discipline;

    switch(discipline){
        case 'soccer':
            console.error(errtxt);
            return 
        case 'rugby' : 
            console.error(errtxt);
            return 
        case 'basket' :
            console.error(errtxt);
            return 
        case 'handball':
            return handballRules.getPeriodByMatchStep(period);
        default:
            console.error(errtxt);
            return [];
    }

}

export const getPeriodByType = (type, discipline) => {

    const errtxt = "Discipline non implémentée getPeriodByType pour :" + discipline;

    switch(discipline){
        case 'soccer':
            console.error(errtxt);
            return 
        case 'rugby' : 
            console.error(errtxt);
            return 
        case 'basket' :
            console.error(errtxt);
            return 
        case 'handball':
            return handballRules.getPeriodByType(type);
        default:
            console.error(errtxt);
            return [];
    }

}

export const getAllMatchPeriods = (discipline) => {

    const errtxt = "getAllMatchPeriods non implémentée pour: " + discipline;

    switch(discipline){
        case 'soccer':
            return soccerRules.getPeriods();
        case 'rugby' : 
            return rugbyRules.getPeriods();
        case 'basket' :
            return basketRules.getPeriods();
        case 'handball':
            return handballRules.getPeriods();
        default:
            console.error("getAllMatchPeriods discipline non reconnue: " + discipline);
            return [];
    }

}

export const getPlayedGamesPeriods = (discipline) => {

    const errtxt = "getPlayedGamesPeriods non implémentée pour: " + discipline;

    switch(discipline){
        case 'soccer':
            return soccerRules.getPlayedGamesPeriods();
        case 'rugby' : 
            return rugbyRules.getPlayedGamesPeriods();
        case 'basket' :
            return basketRules.getPlayedGamesPeriods();
        case 'handball':
            return handballRules.getPlayedGamesPeriods();
        default:
            console.error("getPlayedGamesPeriods discipline non reconnue: " + discipline);
            return [];
    }

}

export const getPeriodPlayedModel = (discipline, matchPeriod) => {

    const errtxt = "getPeriodPlayedModel non implémentée pour: " + discipline;
    switch(discipline){
        case 'soccer':
            return soccerRules.getPeriodPlayedModel(matchPeriod);
        case 'rugby' : 
            return rugbyRules.getPeriodPlayedModel(matchPeriod);
        case 'basket' :     
            return basketRules.getPeriodPlayedModel(matchPeriod);
        case 'handball':
            return handballRules.getPeriodPlayedModel(matchPeriod);
        default:
            console.error("getPeriodPlayedModel discipline non reconnue: " + discipline);
            return null;
    }   
}

export const getUnplayableGamesPeriods = (discipline) => {

    const errtxt = "getPlayedGamesPeriods non implémentée pour: " + discipline;

    switch(discipline){
        case 'soccer':
            return soccerRules.getUnplayableGamesPeriods();
        case 'rugby' : 
            return rugbyRules.getUnplayableGamesPeriods();
        case 'basket' :
            return basketRules.getUnplayableGamesPeriods();
        case 'handball':
            return handballRules.getUnplayableGamesPeriods();
        default:
            console.error("getPlayedGamesPeriods discipline non reconnue: " + discipline);
            return [];
    }

}

export const getSurchargePeriod = (discipline, currentPeriod) => {

    const errtxt = "getSurchargePeriod non implémentée pour: " + discipline;

    switch(discipline){
        case 'soccer':
            console.error(errtxt);
            return 
        case 'rugby' : 
            console.error(errtxt);
            return 
        case 'basket' :
            console.error(errtxt);
            return 
        case 'handball':
            return handballRules.getSurchagePeriod(currentPeriod)?.matchPeriod;
        default:
            console.error("getSurchargePeriod discipline non reconnue: " + discipline);
            return [];
    }
    
}

export function getRegulationEndPeriod(discipline) {
    const all = getAllMatchPeriods(discipline);
    return [...all.values()].find(p => p.isRegulationEnd);
}